import { motion } from 'framer-motion';

import { Box, BoxProps } from 'quotient';

export const MotionBox = motion<Omit<BoxProps, 'transition'>>(Box);
